<template functional>
  <footer class="the-footer flex-wrap justify-between">
    <template v-if="!props.is_program">
      <div class="vx-row">
        <div class="vx-col w-full footer-col px-6">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-1/3 mb-base text-align-last-left">
              <p class="copyright copyright-rg">© Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo | {{props.year}} | Todos los derechos reservados</p>
            </div>
            <div class="vx-col sm:w-full md:w-1/3 mb-base">
              <div class="items-center justify-evenly">
                <img src="https://cdn.redgirasol.com/green/LOGOS/redgirasol-white.png" class="mr-6 mb-1" width="200px" alt="logo">
                <div class="flex flex-wrap items-start mt-1 justify-center">
                  <a href="https://www.instagram.com/redgirasol/" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/instagram-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.facebook.com/redgirasol/" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/facebook-w.png" class="icons-footer" style="width: 1rem;" />
                  </a>
                  <a href="https://x.com/redgirasol/" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/twitter-x-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.linkedin.com/company/10346607/" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/linkedin-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.youtube.com/@redgirasol7972" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/youtube-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.tiktok.com/@redgirasolmx" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/tiktok-w.png" class="icons-footer" />
                  </a>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/3 mb-base text-align-last-right">
              <p class="copyright copyright-rg"><a style="color: #FFF !important;" target="_blank" href="https://www.redgirasol.com/comisiones" rel="noopener noreferrer">Consulta los Costos y las Comisiones de nuestros productos</a></p>
            </div>
            <!-- <div class="vx-col w-full">
              <div class="flex flex-wrap items-center">
                <img src="https://cdn.redgirasol.com/green/LOGOS/redgirasol-white.png" class="mr-6" width="200px" alt="logo">
                <div class="flex flex-wrap items-start mt-2">
                  <a href="https://www.instagram.com/redgirasol/" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/instagram-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.facebook.com/redgirasol/" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/facebook-w.png" class="icons-footer" style="width: 1rem;" />
                  </a>
                  <a href="https://x.com/redgirasol/" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/twitter-x-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.linkedin.com/company/10346607/" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/linkedin-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.youtube.com/@redgirasol7972" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/youtube-w.png" class="icons-footer" />
                  </a>
                  <a href="https://www.tiktok.com/@redgirasolmx" class="ml-6" target="_blank" rel="noopener noreferrer">
                    <image-from-source path="/img/tiktok-w.png" class="icons-footer" />
                  </a>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <hr>
      <!-- <div class="vx-row pt-5 pb-4 items-center justify-between">
        <div class="vx-col lg:w-1/2 md:w-1/3 w-full mb-2">
          <p class="copyright copyright-rg">© Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo | {{props.year}} | Todos los derechos reservados</p>
        </div>
        <div class="vx-col w-full lg:w-1/4 md:w-1/3 w-1/2">
          <p class="copyright copyright-rg"><a style="color: #FFF !important;" target="_blank" href="https://www.redgirasol.com/comisiones" rel="noopener noreferrer">Consulta los Costos y las Comisiones de nuestros productos</a></p>
        </div>
      </div> -->

    </template>    
    <template v-else>
      <div class="vx-row">
        <div class="vx-col w-full mb-5 footer-col px-6">
          <div class="flex fix-logos">
            <div class="" style="float:left" >
              <img src="https://cdn.redgirasol.com/green/LOGOS/redgirasol.png" width="200px" class="mr-auto" style="float:left; margin-top: 8%;" alt="logo">
            </div>
            <div class="ml-4" style="float:left" >
              <img :src="`https://cdn.redgirasol.com/programs/icons/${props.program_info.logo}`" width="100px" class="mr-auto" style="float:left; background-color: white;" alt="logo">
            </div>
            <div class="ml-4" style="float:left" >
              <img :src="`https://cdn.redgirasol.com/programs/icons/giz-logo.png`" width="150px" class="mr-auto" style="float:left; margin-top: 8%; background-color: white;" alt="logo">
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="vx-row pt-5 pb-4">
        <div style="text-align: left;" class="vx-col w-full mb-2 left">
          <p class="copyright">© Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo | {{props.year}} | Todos los derechos reservados.</p>
        </div>
        <div style="text-align: justify;" class="vx-col w-full mb-2 left">
          <p class="copyright">© {{props.program_info.legal_info}}</p>
        </div>
        <div style="text-align: left;" class="vx-col w-full mb-2 left">
          <p class="copyright">© Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH | {{props.year}} | Todos los derechos reservados.</p>
        </div>
      </div>

    </template>
  </footer>
</template>

<script>
import alerts from '@mixins/alerts';
const logos = [
  {
    link: 'https://www.gob.mx/shcp',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-shcp.png',
    alt: 'SHCP'
  },
  {
    link: 'https://www.cnbv.gob.mx/Paginas/default.aspx',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-cnbv.png',
    alt: 'CNBV'
  },
  {
    link: 'https://www.banxico.org.mx/',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-banxico.png',
    alt: 'BANXICO'
  },
  {
    link: 'https://www.condusef.gob.mx/',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-condusef.png',
    alt: 'CONDUSEF'
  },
  {
    link: 'https://www.bcorporation.net/en-us',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-b.png',
    alt: 'B'
  },
  {
    link: 'https://directories.onepercentfortheplanet.org/',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-fortheplanet.png',
    alt: 'For the Planet'
  },
  {
    link: 'http://www.afico.org/',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-afico.png',
    alt: 'AFICO'
  },
  {
    link: 'https://www.circulodecredito.com.mx/home',
    src: 'https://cdn.redgirasol.com/nuevo_portal/logos/footer/logo-footer-cdc.png',
    alt: 'Circulo de Crédito'
  }
];

export default {
  name: "app-footer",
  mixins: [alerts],
  props: {
    year: {
      type: Number
    },
    footer_text: {
      type: String
    },
    is_program: {
      type: Boolean
      , default: false
    },
    program_info: {
      type: Object
      , default: () => {}
    }
  },
  data() {
    return {
      logosPartners: null,
    };
  },
};
</script>

<style>
  .fix-logos{
    max-width: min-content;
  }

  .copyright {
    color: #FFF;
    font-size: 12px;
  }

  .icons-footer {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    .text-align-last-left,
    .text-align-last-right {
      text-align: center;
      text-align-last: center;
    }
  }
</style>
